﻿import { DateString } from '@core/_globals/types/date-settings';
import FIMenuCustomerViewed from './FIMenuCustomerViewed';
import { IMeetingDetails } from '@core/_interfaces/MeetingTypes';

export default class MeetingInfo {
	id?: string;
	dealId?: string;
	employeeId?: string;
	employeeCode?: string;
	meetingCode?: string;
	inStore: boolean;
	dealNumber?: string;
	storeCode?: string;
	verificationCode?: string;
	language?: string;
	startedAt?: Date | DateString;
	finishedAt?: Date | DateString;
	validAfter?: Date | DateString;
	validUntil?: Date | DateString;
	meetingLogs?: FIMenuCustomerViewed[] = [];

	meetings?: IMeetingDetails[] = [];

	constructor(init?: Partial<MeetingInfo>) {
		this.id = init?.id;
		this.dealId = init?.dealId;
		this.employeeId = init?.employeeId;
		this.employeeCode = init?.employeeCode;
		this.inStore = init?.inStore;
		this.language = init?.language;
		this.dealNumber = init?.dealNumber;
		this.storeCode = init?.storeCode;
		this.meetingCode = init?.meetingCode;
		this.validAfter = init?.validAfter;
		this.validUntil = init?.validUntil;
		this.startedAt = init?.startedAt;
		this.finishedAt = init?.finishedAt;

		this.meetingLogs = init?.meetingLogs?.map(ml => new FIMenuCustomerViewed(ml)) ?? [];
		this.meetings = [];
	}
}
